import React, { useMemo } from 'react';
import { ThemeProvider } from './presentation/theme';
import { AuthenticationProvider } from './application/context/AuthenticationContext';
import { OrganizationProvider } from './application/context/OrganizationContext';
import { NotificationProvider } from './application/context/NotificationContext';
import { ServicesProvider } from './application/context/ServicesContext';
import { CGUAcceptanceProvider } from './application/context/CGUAcceptanceContext';
import { FirebaseServiceContainer } from './infrastructure/containers/FirebaseServiceContainer';
import { FirebaseAuthAdapter } from './infrastructure/adapters/FirebaseAuthAdapter';
import { FirebaseUserRepository } from './infrastructure/repositories/FirebaseUserRepository';
import { AuthenticationService } from './application/services/AuthenticationService';
import { CGUAcceptanceService } from './application/services/CGUAcceptanceService';
import AppRouter from './presentation/components/navigation/AppRouter';
import GlobalSnackbar from './presentation/components/shared/organisms/GlobalSnackbar';

function App() {
  // Dependency injection setup - memoized to prevent re-creation on every render
  const serviceContainer = useMemo(() => FirebaseServiceContainer.getInstance(), []);

  const authRepository = useMemo(
    () => new FirebaseAuthAdapter(serviceContainer.loggerService),
    [serviceContainer]
  );

  const userRepository = useMemo(
    () => new FirebaseUserRepository(serviceContainer.loggerService),
    [serviceContainer]
  );

  const authenticationService = useMemo(
    () => new AuthenticationService(authRepository, userRepository),
    [authRepository, userRepository]
  );

  const cguAcceptanceService = useMemo(
    () => new CGUAcceptanceService(userRepository),
    [userRepository]
  );

  return (
    <ThemeProvider>
      <ServicesProvider serviceContainer={serviceContainer}>
        <NotificationProvider>
          <AuthenticationProvider authenticationPort={authenticationService}>
            <OrganizationProvider>
              <CGUAcceptanceProvider cguAcceptanceService={cguAcceptanceService}>
                <AppRouter />
                <GlobalSnackbar />
              </CGUAcceptanceProvider>
            </OrganizationProvider>
          </AuthenticationProvider>
        </NotificationProvider>
      </ServicesProvider>
    </ThemeProvider>
  );
}

export default App;
